import {Injectable} from '@angular/core';
import {AuthenticationService} from "./authentication.service";
import {LoginHelper} from "../helpers";
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class ApiKeyService {
  constructor(public http: HttpClient,
              public authenticationService: AuthenticationService,
              public config: IndexConfigService) {
  }

  getAll(password) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .post<any>(this.config.api + '/api/apiKeys/get/all', {password: password})
      ;
  }

  @Load()
  create() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .post<any>(this.config.api + '/api/apiKeys/create/', {})
      ;
  }

  @Load()
  setIsGet(id, value) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .post<any>(this.config.api + '/api/apiKeys/' + id + '/get/' + value + '', {})
      ;
  }

  @Load()
  setIsPost(id, value) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .post<any>(this.config.api + '/api/apiKeys/' + id + '/post/' + value + '', {})
      ;
  }

  @Load()
  delete(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .delete(this.config.api + '/api/apiKeys/delete/' + id + '')
      ;
  }
}
